import { useCompanyIdentity } from '../../hooks/useCompanyIdentity';
import { legalFor } from '../../utils/legalIdentity';

// Company details for the Terms / Refund / Privacy pages (see utils/legalIdentity.js).
export const useLegal = () => legalFor(useCompanyIdentity('catv'));

// For the page text that sits at module level, outside any component.
export const CompanyName = () => useLegal().name;
